import { createContext } from '../../../@rc-component/context/es/context.js';
import '../../../rc-util/es/ref.js';
import 'react';
var StaticContext = createContext(null);
var GridContext = createContext(null);
export { GridContext, StaticContext };
//# sourceMappingURL=context.js.map
